import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserDataService } from 'src/data-store/user-data.service';
import { LOGIN_REDIRECT_PATH } from 'src/models/routes.model';
import { EContractsComposition } from 'src/models/user.model';
import { NotificationService } from 'src/services/notification.service';

@Injectable({
  providedIn: 'root'
})
/**
 * Should not be used on any landing pages. Mainly used on creating investments routes.
 */
export class ValidContractsGuard  {
  private router = inject(Router);
  private userDataService = inject(UserDataService);
  private translateService = inject(TranslateService);
  private notificationService = inject(NotificationService);

  public canActivate(): boolean {
    const contractsStats = this.userDataService.contractsStats();
    if (!contractsStats || contractsStats.contractsComposition === EContractsComposition.NO_CONTRACT) {
      this.router.navigate([LOGIN_REDIRECT_PATH]);
      this.notificationService.warning(
        this.translateService.instant('toastNotifications.headers.noAccess'),
        this.translateService.instant('toastNotifications.messages.noAccess')
      );
      false;
    }
    return true;
  }
}